import { ButtonSwitch, ButtonSwitchItem, ButtonSwitchProps } from '@finviz/website'

export function ButtonSwitchElement<ValueType extends string, ItemType extends ButtonSwitchItem<ValueType>>(
  props: Omit<ButtonSwitchProps<ValueType, ItemType>, 'onChange'> & { onChange: (value: string) => void }
) {
  return <ButtonSwitch {...props} onChange={(value) => props.onChange(value.value)} />
}
